// TODO: merge with src/Enums/ReportingDashboard/ReportView/ReportView.enum.ts
enum WebVisitsReportViewEnum {
  Date = 'Day',
  Channel = 'Digital Channel',
  Device = 'Device Type',
  Campaign = 'Campaign Name',
  Placement = 'Line Item Name',
  Pixel = 'Pixel',
  Creative = 'Creative Name',
  Publisher = 'Publisher Name',
  DaysOfWeek = 'Day Of Week',
  Daypart = 'Daypart',
}

export default WebVisitsReportViewEnum;
